export const title = "Payment Summary";
export const applicationTitle = "Application Summary";
export const confirm = "Confirm";
export const back = "Back";
export const empty = "None here";
export const processing = "Processing ... ";
